
<template>
	<v-card>
		<v-form class="text-xs-left">
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<v-container>
				<v-text-field ref="name" v-model="$v.form.name.$model" label="Location Name" :error-messages="errorsName" required/>
				<v-textarea v-model="form.description" label="Description" rows="1" auto-grow></v-textarea>

				<h3 class="mt-4">Address Details (optional)</h3>
				<v-text-field v-model="$v.form.addressLine1.$model" label="Address line 1" :error-messages="errorsAddress1" required/>
				<v-text-field v-model="form.addressLine2" label="Address line 2"/>
				<v-text-field v-model="$v.form.city.$model" label="Suburb/City" required :error-messages="errorsCity"/>
				<v-text-field v-model="$v.form.postcode.$model" label="Postcode" required :error-messages="errorsPostcode"/>
				<v-select v-model="$v.form.state.$model" label="State" :items="['NSW', 'VIC', 'WA', 'NT', 'SA', 'QLD', 'ACT']" required :error-messages="errorsState"/>
			</v-container>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="closeEditor">Cancel</v-btn>
				<v-btn class="primary" @click="onUpsertClick" :disabled="isSaving" flat>
					Save
				</v-btn>
			</v-card-actions>
		</v-form>

	</v-card>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		name: 'AssetLocationEditor',
		props: {
			// Pass in a form to edit. Otherwise, it will be all new values
			location: {
				type: Object,
				default: undefined
			},
			isSaving: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form : {
					name: '',
					addressLine1: '',
					addressLine2: '',
					city: '',
					state: '',
					postcode: '',
					description: '',
				}
			}
		},
		computed: {
			isNewLocation() {
				return !!!this.location
			},
			errorsName() {
				if (!this.$v.form.name.$dirty || !this.$v.form.name.$error) return []
				return ['Name is required.']
			},
			errorsAddress1() {
				if (!this.$v.form.addressLine1.$dirty || !this.$v.form.addressLine1.$error) return []
				return ['Address Line 1 is required.']
			},
			errorsCity() {
				if (!this.$v.form.city.$dirty || !this.$v.form.city.$error) return []
				return ['City is required.']
			},
			errorsState() {
				if (!this.$v.form.state.$dirty || !this.$v.form.state.$error) return []
				return ['State is required.']
			},
			errorsPostcode() {
				if (!this.$v.form.postcode.$dirty || !this.$v.form.postcode.$error) return []
				return ['Postcode is required.']
			},
			title() {
				return this.isNewLocation ? 'New Location' : 'Edit Location';
			}
		},
		watch: {
			location() {
				this.populateForm()
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.$refs.name.focus();
			});
		},
		methods: {
			clear() {
				this.$v.$reset()
				this.populateForm()
			},
			populateForm() {
				if (this.location) {
					this.form = {...this.location}
				}
				else {
					this.form.name =  ''
					this.form.addressLine1 = ''
					this.form.addressLine2 = ''
					this.form.city = ''
					this.form.state = ''
					this.form.postcode = ''
					this.form.description = ''
				}
			},
			onUpsertClick() {
				this.$v.$touch()
				if (!this.$v.$invalid) {
					const filledForm = {
						...this.form,
						id: this.location ? this.location.id : null,
						parentLocationId: this.location ? this.location.parentLocationId : null,
					}
					this.$emit('onSave', filledForm);
				}
			},
			closeEditor() {
				this.clear();
				this.$emit('closeEditor');
			}
		},
		created() {
			this.clear()
		},
		mixins: [validationMixin],
		validations:  {
			form: {
				name: { required },
				addressLine1: { },
				city: { },
				state: { },
				postcode: { },
			}
		}
	};
</script>